const ButtonsType = Object.freeze({
    Link: 'link',
    ExternalLink: 'externalLink',
    Button: 'button',
});


export { ButtonsType };